export const COUNTRIES = [
  {
    country_id: 52,
    country_value: 'Albania',
    country_code: 'al',
    mobile_country_code: '+355',
  },
  {
    country_id: 48,
    country_value: 'Algeria',
    country_code: 'dz',
    mobile_country_code: '+213',
  },
  {
    country_id: 53,
    country_value: 'Andorra',
    country_code: 'ad',
    mobile_country_code: '+376',
  },
  {
    country_id: 54,
    country_value: 'Angola',
    country_code: 'ao',
    mobile_country_code: '+244',
  },
  {
    country_id: 55,
    country_value: 'Antigua and Barbuda',
    country_code: 'ag',
    mobile_country_code: '+1268',
  },
  {
    country_id: 1,
    country_value: 'Argentina',
    country_code: 'ar',
    mobile_country_code: '+54',
  },
  {
    country_id: 56,
    country_value: 'Armenia',
    country_code: 'am',
    mobile_country_code: '+374',
  },
  {
    country_id: 2,
    country_value: 'Australia',
    country_code: 'au',
    mobile_country_code: '+61',
  },
  {
    country_id: 3,
    country_value: 'Austria',
    country_code: 'at',
    mobile_country_code: '+43',
  },
  {
    country_id: 57,
    country_value: 'Azerbaijan',
    country_code: 'az',
    mobile_country_code: '+994',
  },
  {
    country_id: 58,
    country_value: 'Bahamas',
    country_code: 'bs',
    mobile_country_code: '+1242',
  },
  {
    country_id: 35,
    country_value: 'Bahrain',
    country_code: 'bh',
    mobile_country_code: '+973',
  },
  {
    country_id: 59,
    country_value: 'Bangladesh',
    country_code: 'bd',
    mobile_country_code: '+880',
  },
  {
    country_id: 60,
    country_value: 'Barbados',
    country_code: 'bb',
    mobile_country_code: '+1246',
  },
  {
    country_id: 61,
    country_value: 'Belarus',
    country_code: 'by',
    mobile_country_code: '+375',
  },
  {
    country_id: 4,
    country_value: 'Belgium',
    country_code: 'be',
    mobile_country_code: '+32',
  },
  {
    country_id: 62,
    country_value: 'Belize',
    country_code: 'bz',
    mobile_country_code: '+501',
  },
  {
    country_id: 63,
    country_value: 'Benin',
    country_code: 'bj',
    mobile_country_code: '+229',
  },
  {
    country_id: 64,
    country_value: 'Bhutan',
    country_code: 'bt',
    mobile_country_code: '+975',
  },
  {
    country_id: 65,
    country_value: 'Bolivia',
    country_code: 'bo',
    mobile_country_code: '+591',
  },
  {
    country_id: 66,
    country_value: 'Bosnia and Herzegovina',
    country_code: 'ba',
    mobile_country_code: '+387',
  },
  {
    country_id: 67,
    country_value: 'Botswana',
    country_code: 'bw',
    mobile_country_code: '+267',
  },
  {
    country_id: 33,
    country_value: 'Brazil',
    country_code: 'br',
    mobile_country_code: '+55',
  },
  {
    country_id: 68,
    country_value: 'Brunei',
    country_code: 'bn',
    mobile_country_code: '+673',
  },
  {
    country_id: 69,
    country_value: 'Bulgaria',
    country_code: 'bg',
    mobile_country_code: '+359',
  },
  {
    country_id: 70,
    country_value: 'Burkina Faso',
    country_code: 'bf',
    mobile_country_code: '+226',
  },
  {
    country_id: 72,
    country_value: 'Burundi',
    country_code: 'bi',
    mobile_country_code: '+257',
  },
  {
    country_id: 73,
    country_value: 'Cambodia',
    country_code: 'kh',
    mobile_country_code: '+855',
  },
  {
    country_id: 74,
    country_value: 'Cameroon',
    country_code: 'cm',
    mobile_country_code: '+237',
  },
  {
    country_id: 5,
    country_value: 'Canada',
    country_code: 'ca',
    mobile_country_code: '+1',
  },
  {
    country_id: 75,
    country_value: 'Cape Verde',
    country_code: 'cv',
    mobile_country_code: '+238',
  },
  {
    country_id: 76,
    country_value: 'Central African Republic',
    country_code: 'cf',
    mobile_country_code: '+236',
  },
  {
    country_id: 77,
    country_value: 'Chad',
    country_code: 'td',
    mobile_country_code: '+235',
  },
  {
    country_id: 6,
    country_value: 'Chile',
    country_code: 'cl',
    mobile_country_code: '+56',
  },
  {
    country_id: 7,
    country_value: 'China',
    country_code: 'cn',
    mobile_country_code: '+86',
  },
  {
    country_id: 8,
    country_value: 'Colombia',
    country_code: 'co',
    mobile_country_code: '+57',
  },
  {
    country_id: 78,
    country_value: 'Comoros',
    country_code: 'km',
    mobile_country_code: '+269',
  },
  {
    country_id: 79,
    country_value: 'Congo (Brazzaville)',
    country_code: 'cg',
    mobile_country_code: '+242',
  },
  {
    country_id: 80,
    country_value: 'Congo (Kinshasa)',
    country_code: 'cd',
    mobile_country_code: '+243',
  },
  {
    country_id: 81,
    country_value: 'Costa Rica',
    country_code: 'cr',
    mobile_country_code: '+506',
  },
  {
    country_id: 82,
    country_value: "Cote d'Ivoire",
    country_code: 'ci',
    mobile_country_code: '+225',
  },
  {
    country_id: 83,
    country_value: 'Croatia',
    country_code: 'hr',
    mobile_country_code: '+385',
  },
  {
    country_id: 84,
    country_value: 'Cuba',
    country_code: 'cu',
    mobile_country_code: '+53',
  },
  {
    country_id: 85,
    country_value: 'Cyprus',
    country_code: 'cy',
    mobile_country_code: '+357',
  },
  {
    country_id: 86,
    country_value: 'Czechia',
    country_code: 'cz',
    mobile_country_code: '+420',
  },
  {
    country_id: 9,
    country_value: 'Denmark',
    country_code: 'dk',
    mobile_country_code: '+45',
  },
  {
    country_id: 87,
    country_value: 'Djibouti',
    country_code: 'dj',
    mobile_country_code: '+253',
  },
  {
    country_id: 88,
    country_value: 'Dominica',
    country_code: 'dm',
    mobile_country_code: '+1767',
  },
  {
    country_id: 89,
    country_value: 'Dominican Republic',
    country_code: 'do',
    mobile_country_code: '+1809',
  },
  {
    country_id: 91,
    country_value: 'Ecuador',
    country_code: 'ec',
    mobile_country_code: '+593',
  },
  {
    country_id: 92,
    country_value: 'Egypt',
    country_code: 'eg',
    mobile_country_code: '+20',
  },
  {
    country_id: 93,
    country_value: 'El Salvador',
    country_code: 'sv',
    mobile_country_code: '+503',
  },
  {
    country_id: 94,
    country_value: 'Equatorial Guinea',
    country_code: 'gq',
    mobile_country_code: '+240',
  },
  {
    country_id: 95,
    country_value: 'Eritrea',
    country_code: 'er',
    mobile_country_code: '+291',
  },
  {
    country_id: 96,
    country_value: 'Estonia',
    country_code: 'ee',
    mobile_country_code: '+372',
  },
  {
    country_id: 183,
    country_value: 'Eswatini',
    country_code: 'sz',
    mobile_country_code: '+268',
  },
  {
    country_id: 97,
    country_value: 'Ethiopia',
    country_code: 'et',
    mobile_country_code: '+251',
  },
  {
    country_id: 98,
    country_value: 'Fiji',
    country_code: 'fj',
    mobile_country_code: '+679',
  },
  {
    country_id: 10,
    country_value: 'Finland',
    country_code: 'fi',
    mobile_country_code: '+358',
  },
  {
    country_id: 11,
    country_value: 'France',
    country_code: 'fr',
    mobile_country_code: '+33',
  },
  {
    country_id: 99,
    country_value: 'Gabon',
    country_code: 'ga',
    mobile_country_code: '+241',
  },
  {
    country_id: 100,
    country_value: 'Gambia',
    country_code: 'gm',
    mobile_country_code: '+220',
  },
  {
    country_id: 101,
    country_value: 'Georgia',
    country_code: 'ge',
    mobile_country_code: '+995',
  },
  {
    country_id: 12,
    country_value: 'Germany',
    country_code: 'de',
    mobile_country_code: '+49',
  },
  {
    country_id: 102,
    country_value: 'Ghana',
    country_code: 'gh',
    mobile_country_code: '+233',
  },
  {
    country_id: 103,
    country_value: 'Greece',
    country_code: 'gr',
    mobile_country_code: '+30',
  },
  {
    country_id: 104,
    country_value: 'Grenada',
    country_code: 'gd',
    mobile_country_code: '+1473',
  },
  {
    country_id: 105,
    country_value: 'Guatemala',
    country_code: 'gt',
    mobile_country_code: '+502',
  },
  {
    country_id: 106,
    country_value: 'Guinea',
    country_code: 'gn',
    mobile_country_code: '+224',
  },
  {
    country_id: 107,
    country_value: 'Guinea-Bissau',
    country_code: 'gw',
    mobile_country_code: '+245',
  },
  {
    country_id: 108,
    country_value: 'Guyana',
    country_code: 'gy',
    mobile_country_code: '+592',
  },
  {
    country_id: 109,
    country_value: 'Haiti',
    country_code: 'ht',
    mobile_country_code: '+509',
  },
  {
    country_id: 110,
    country_value: 'Holy See',
    country_code: 'va',
    mobile_country_code: '+379',
  },
  {
    country_id: 111,
    country_value: 'Honduras',
    country_code: 'hn',
    mobile_country_code: '+504',
  },
  {
    country_id: 112,
    country_value: 'Hong Kong',
    country_code: 'hk',
    mobile_country_code: '+852',
  },
  {
    country_id: 113,
    country_value: 'Hungary',
    country_code: 'hu',
    mobile_country_code: '+36',
  },
  {
    country_id: 114,
    country_value: 'Iceland',
    country_code: 'is',
    mobile_country_code: '+354',
  },
  {
    country_id: 13,
    country_value: 'India',
    country_code: 'in',
    mobile_country_code: '+91',
  },
  {
    country_id: 115,
    country_value: 'Indonesia',
    country_code: 'id',
    mobile_country_code: '+62',
  },
  {
    country_id: 45,
    country_value: 'Iran',
    country_code: 'ir',
    mobile_country_code: '+98',
  },
  {
    country_id: 116,
    country_value: 'Iraq',
    country_code: 'iq',
    mobile_country_code: '+964',
  },
  {
    country_id: 117,
    country_value: 'Ireland',
    country_code: 'ie',
    mobile_country_code: '+353',
  },
  {
    country_id: 118,
    country_value: 'Israel',
    country_code: 'il',
    mobile_country_code: '+972',
  },
  {
    country_id: 14,
    country_value: 'Italy',
    country_code: 'it',
    mobile_country_code: '+39',
  },
  {
    country_id: 119,
    country_value: 'Jamaica',
    country_code: 'jm',
    mobile_country_code: '+1876',
  },
  {
    country_id: 15,
    country_value: 'Japan',
    country_code: 'jp',
    mobile_country_code: '+81',
  },
  {
    country_id: 43,
    country_value: 'Jordan',
    country_code: 'jo',
    mobile_country_code: '+962',
  },
  {
    country_id: 120,
    country_value: 'Kazakhstan',
    country_code: 'kz',
    mobile_country_code: '+7',
  },
  {
    country_id: 121,
    country_value: 'Kenya',
    country_code: 'ke',
    mobile_country_code: '+254',
  },
  {
    country_id: 122,
    country_value: 'Kiribati',
    country_code: 'ki',
    mobile_country_code: '+686',
  },
  {
    country_id: 123,
    country_value: 'North Korea',
    country_code: 'kp',
    mobile_country_code: '+850',
  },
  {
    country_id: 36,
    country_value: 'Kuwait',
    country_code: 'kw',
    mobile_country_code: '+965',
  },
  {
    country_id: 124,
    country_value: 'Kyrgyzstan',
    country_code: 'kg',
    mobile_country_code: '+996',
  },
  {
    country_id: 125,
    country_value: 'Laos',
    country_code: 'la',
    mobile_country_code: '+856',
  },
  {
    country_id: 126,
    country_value: 'Latvia',
    country_code: 'lv',
    mobile_country_code: '+371',
  },
  {
    country_id: 42,
    country_value: 'Lebanon',
    country_code: 'lb',
    mobile_country_code: '+961',
  },
  {
    country_id: 127,
    country_value: 'Lesotho',
    country_code: 'ls',
    mobile_country_code: '+266',
  },
  {
    country_id: 128,
    country_value: 'Liberia',
    country_code: 'lr',
    mobile_country_code: '+231',
  },
  {
    country_id: 49,
    country_value: 'Libya',
    country_code: 'ly',
    mobile_country_code: '+218',
  },
  {
    country_id: 129,
    country_value: 'Liechtenstein',
    country_code: 'li',
    mobile_country_code: '+423',
  },
  {
    country_id: 130,
    country_value: 'Lithuania',
    country_code: 'lt',
    mobile_country_code: '+370',
  },
  {
    country_id: 131,
    country_value: 'Luxembourg',
    country_code: 'lu',
    mobile_country_code: '+352',
  },
  {
    country_id: 132,
    country_value: 'Macau',
    country_code: 'mo',
    mobile_country_code: '+853',
  },
  {
    country_id: 134,
    country_value: 'Madagascar',
    country_code: 'mg',
    mobile_country_code: '+261',
  },
  {
    country_id: 135,
    country_value: 'Malawi',
    country_code: 'mw',
    mobile_country_code: '+265',
  },
  {
    country_id: 136,
    country_value: 'Malaysia',
    country_code: 'my',
    mobile_country_code: '+60',
  },
  {
    country_id: 137,
    country_value: 'Maldives',
    country_code: 'mv',
    mobile_country_code: '+960',
  },
  {
    country_id: 138,
    country_value: 'Mali',
    country_code: 'ml',
    mobile_country_code: '+223',
  },
  {
    country_id: 139,
    country_value: 'Malta',
    country_code: 'mt',
    mobile_country_code: '+356',
  },
  {
    country_id: 140,
    country_value: 'Marshall Islands',
    country_code: 'mh',
    mobile_country_code: '+692',
  },
  {
    country_id: 141,
    country_value: 'Mauritania',
    country_code: 'mr',
    mobile_country_code: '+222',
  },
  {
    country_id: 142,
    country_value: 'Mauritius',
    country_code: 'mu',
    mobile_country_code: '+230',
  },
  {
    country_id: 17,
    country_value: 'Mexico',
    country_code: 'mx',
    mobile_country_code: '+52',
  },
  {
    country_id: 143,
    country_value: 'Micronesia (Federated States of)',
    country_code: 'fm',
    mobile_country_code: '+691',
  },
  {
    country_id: 144,
    country_value: 'Moldova',
    country_code: 'md',
    mobile_country_code: '+373',
  },
  {
    country_id: 145,
    country_value: 'Monaco',
    country_code: 'mc',
    mobile_country_code: '+377',
  },
  {
    country_id: 146,
    country_value: 'Mongolia',
    country_code: 'mn',
    mobile_country_code: '+976',
  },
  {
    country_id: 147,
    country_value: 'Montenegro',
    country_code: 'me',
    mobile_country_code: '+382',
  },
  {
    country_id: 50,
    country_value: 'Morocco',
    country_code: 'ma',
    mobile_country_code: '+212',
  },
  {
    country_id: 148,
    country_value: 'Mozambique',
    country_code: 'mz',
    mobile_country_code: '+258',
  },
  {
    country_id: 71,
    country_value: 'Myanmar',
    country_code: 'mm',
    mobile_country_code: '+95',
  },
  {
    country_id: 149,
    country_value: 'Namibia',
    country_code: 'na',
    mobile_country_code: '+264',
  },
  {
    country_id: 150,
    country_value: 'Nauru',
    country_code: 'nr',
    mobile_country_code: '+674',
  },
  {
    country_id: 151,
    country_value: 'Nepal',
    country_code: 'np',
    mobile_country_code: '+977',
  },
  {
    country_id: 18,
    country_value: 'Netherlands',
    country_code: 'nl',
    mobile_country_code: '+31',
  },
  {
    country_id: 153,
    country_value: 'New Zealand',
    country_code: 'nz',
    mobile_country_code: '+64',
  },
  {
    country_id: 154,
    country_value: 'Nicaragua',
    country_code: 'ni',
    mobile_country_code: '+505',
  },
  {
    country_id: 155,
    country_value: 'Niger',
    country_code: 'ne',
    mobile_country_code: '+227',
  },
  {
    country_id: 156,
    country_value: 'Nigeria',
    country_code: 'ng',
    mobile_country_code: '+234',
  },
  {
    country_id: 133,
    country_value: 'North Macedonia',
    country_code: 'mk',
    mobile_country_code: '+389',
  },
  {
    country_id: 157,
    country_value: 'Norway',
    country_code: 'no',
    mobile_country_code: '+47',
  },
  {
    country_id: 37,
    country_value: 'Oman',
    country_code: 'om',
    mobile_country_code: '+968',
  },
  {
    country_id: 31,
    country_value: 'Other',
    country_code: 'xx',
    mobile_country_code: '+0',
  },
  {
    country_id: 158,
    country_value: 'Pakistan',
    country_code: 'pk',
    mobile_country_code: '+92',
  },
  {
    country_id: 159,
    country_value: 'Palau',
    country_code: 'pw',
    mobile_country_code: '+680',
  },
  {
    country_id: 160,
    country_value: 'State of Palestine',
    country_code: 'ps',
    mobile_country_code: '+970',
  },
  {
    country_id: 161,
    country_value: 'Panama',
    country_code: 'pa',
    mobile_country_code: '+507',
  },
  {
    country_id: 162,
    country_value: 'Papua New Guinea',
    country_code: 'pg',
    mobile_country_code: '+675',
  },
  {
    country_id: 163,
    country_value: 'Paraguay',
    country_code: 'py',
    mobile_country_code: '+595',
  },
  {
    country_id: 19,
    country_value: 'Peru',
    country_code: 'pe',
    mobile_country_code: '+51',
  },
  {
    country_id: 164,
    country_value: 'Philippines',
    country_code: 'ph',
    mobile_country_code: '+63',
  },
  {
    country_id: 20,
    country_value: 'Poland',
    country_code: 'pl',
    mobile_country_code: '+48',
  },
  {
    country_id: 21,
    country_value: 'Portugal',
    country_code: 'pt',
    mobile_country_code: '+351',
  },
  {
    country_id: 38,
    country_value: 'Qatar',
    country_code: 'qa',
    mobile_country_code: '+974',
  },
  {
    country_id: 165,
    country_value: 'Romania',
    country_code: 'ro',
    mobile_country_code: '+40',
  },
  {
    country_id: 34,
    country_value: 'Russia',
    country_code: 'ru',
    mobile_country_code: '+7',
  },
  {
    country_id: 166,
    country_value: 'Rwanda',
    country_code: 'rw',
    mobile_country_code: '+250',
  },
  {
    country_id: 167,
    country_value: 'Saint Kitts and Nevis',
    country_code: 'kn',
    mobile_country_code: '+1869',
  },
  {
    country_id: 168,
    country_value: 'Saint Lucia',
    country_code: 'lc',
    mobile_country_code: '+1758',
  },
  {
    country_id: 169,
    country_value: 'Saint Vincent and the Grenadines',
    country_code: 'vc',
    mobile_country_code: '+1784',
  },
  {
    country_id: 170,
    country_value: 'Samoa',
    country_code: 'ws',
    mobile_country_code: '+685',
  },
  {
    country_id: 171,
    country_value: 'San Marino',
    country_code: 'sm',
    mobile_country_code: '+378',
  },
  {
    country_id: 172,
    country_value: 'Sao Tome and Principe',
    country_code: 'st',
    mobile_country_code: '+239',
  },
  {
    country_id: 39,
    country_value: 'Saudi Arabia',
    country_code: 'sa',
    mobile_country_code: '+966',
  },
  {
    country_id: 173,
    country_value: 'Senegal',
    country_code: 'sn',
    mobile_country_code: '+221',
  },
  {
    country_id: 174,
    country_value: 'Serbia',
    country_code: 'rs',
    mobile_country_code: '+381',
  },
  {
    country_id: 175,
    country_value: 'Seychelles',
    country_code: 'sc',
    mobile_country_code: '+248',
  },
  {
    country_id: 176,
    country_value: 'Sierra Leone',
    country_code: 'sl',
    mobile_country_code: '+232',
  },
  {
    country_id: 22,
    country_value: 'Singapore',
    country_code: 'sg',
    mobile_country_code: '+65',
  },
  {
    country_id: 177,
    country_value: 'Slovakia',
    country_code: 'sk',
    mobile_country_code: '+421',
  },
  {
    country_id: 178,
    country_value: 'Slovenia',
    country_code: 'si',
    mobile_country_code: '+386',
  },
  {
    country_id: 179,
    country_value: 'Solomon Islands',
    country_code: 'sb',
    mobile_country_code: '+677',
  },
  {
    country_id: 180,
    country_value: 'Somalia',
    country_code: 'so',
    mobile_country_code: '+252',
  },
  {
    country_id: 23,
    country_value: 'South Africa',
    country_code: 'za',
    mobile_country_code: '+27',
  },
  {
    country_id: 16,
    country_value: 'South Korea',
    country_code: 'kr',
    mobile_country_code: '+82',
  },
  {
    country_id: 199,
    country_value: 'South Sudan',
    country_code: 'ss',
    mobile_country_code: '+211',
  },
  {
    country_id: 24,
    country_value: 'Spain',
    country_code: 'es',
    mobile_country_code: '+34',
  },
  {
    country_id: 181,
    country_value: 'Sri Lanka',
    country_code: 'lk',
    mobile_country_code: '+94',
  },
  {
    country_id: 46,
    country_value: 'Sudan',
    country_code: 'sd',
    mobile_country_code: '+249',
  },
  {
    country_id: 182,
    country_value: 'Suriname',
    country_code: 'sr',
    mobile_country_code: '+597',
  },
  {
    country_id: 32,
    country_value: 'Sweden',
    country_code: 'se',
    mobile_country_code: '+46',
  },
  {
    country_id: 25,
    country_value: 'Switzerland',
    country_code: 'ch',
    mobile_country_code: '+41',
  },
  {
    country_id: 44,
    country_value: 'Syria',
    country_code: 'sy',
    mobile_country_code: '+963',
  },
  {
    country_id: 26,
    country_value: 'Taiwan',
    country_code: 'tw',
    mobile_country_code: '+886',
  },
  {
    country_id: 184,
    country_value: 'Tajikistan',
    country_code: 'tj',
    mobile_country_code: '+992',
  },
  {
    country_id: 185,
    country_value: 'Tanzania',
    country_code: 'tz',
    mobile_country_code: '+255',
  },
  {
    country_id: 51,
    country_value: 'Thailand',
    country_code: 'th',
    mobile_country_code: '+66',
  },
  {
    country_id: 90,
    country_value: 'Timor-Leste',
    country_code: 'tl',
    mobile_country_code: '+670',
  },
  {
    country_id: 186,
    country_value: 'Togo',
    country_code: 'tg',
    mobile_country_code: '+228',
  },
  {
    country_id: 187,
    country_value: 'Tonga',
    country_code: 'to',
    mobile_country_code: '+676',
  },
  {
    country_id: 188,
    country_value: 'Trinidad and Tobago',
    country_code: 'tt',
    mobile_country_code: '+1868',
  },
  {
    country_id: 47,
    country_value: 'Tunisia',
    country_code: 'tn',
    mobile_country_code: '+216',
  },
  {
    country_id: 27,
    country_value: 'Türkiye',
    country_code: 'tr',
    mobile_country_code: '+90',
  },
  {
    country_id: 189,
    country_value: 'Turkmenistan',
    country_code: 'tm',
    mobile_country_code: '+993',
  },
  {
    country_id: 190,
    country_value: 'Tuvalu',
    country_code: 'tv',
    mobile_country_code: '+688',
  },
  {
    country_id: 191,
    country_value: 'Uganda',
    country_code: 'ug',
    mobile_country_code: '+256',
  },
  {
    country_id: 192,
    country_value: 'Ukraine',
    country_code: 'ua',
    mobile_country_code: '+380',
  },
  {
    country_id: 40,
    country_value: 'United Arab Emirates',
    country_code: 'ae',
    mobile_country_code: '+971',
  },
  {
    country_id: 28,
    country_value: 'United Kingdom',
    country_code: 'gb',
    mobile_country_code: '+44',
  },
  {
    country_id: 29,
    country_value: 'United States of America',
    country_code: 'us',
    mobile_country_code: '+1',
  },
  {
    country_id: 193,
    country_value: 'Uruguay',
    country_code: 'uy',
    mobile_country_code: '+598',
  },
  {
    country_id: 194,
    country_value: 'Uzbekistan',
    country_code: 'uz',
    mobile_country_code: '+998',
  },
  {
    country_id: 195,
    country_value: 'Vanuatu',
    country_code: 'vu',
    mobile_country_code: '+678',
  },
  {
    country_id: 30,
    country_value: 'Venezuela',
    country_code: 've',
    mobile_country_code: '+58',
  },
  {
    country_id: 196,
    country_value: 'Vietnam',
    country_code: 'vn',
    mobile_country_code: '+84',
  },
  {
    country_id: 41,
    country_value: 'Yemen',
    country_code: 'ye',
    mobile_country_code: '+967',
  },
  {
    country_id: 197,
    country_value: 'Zambia',
    country_code: 'zm',
    mobile_country_code: '+260',
  },
  {
    country_id: 198,
    country_value: 'Zimbabwe',
    country_code: 'zw',
    mobile_country_code: '+263',
  },
];